var map = {
	"./flag_chi.png": 20716,
	"./flag_chi.svg": 55712,
	"./flag_en.png": 45480,
	"./flag_en.svg": 93442,
	"./flag_eng.png": 95588,
	"./flag_eng.svg": 58128,
	"./flag_fil.png": 45596,
	"./flag_mao.gif": 27261,
	"./flag_mao.png": 1731,
	"./flag_mao.svg": 30340,
	"./flag_nor.png": 52324,
	"./flag_tr.png": 88996,
	"./flag_tr.svg": 23819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52845;